import api from './';

export const permissoes = async (pessoaId, empresaId, menuId, menuSubId) => {
    try {
        const { data } = await api.get('/servicePermissoesUsuarios', { params: { pessoaId, empresaId, menuId, menuSubId } });
        return data;
    } catch (error) {
        return error;
    }
};
/**
 *
 * @param {*} pessoaId é um array de pessoas
 * @param {*} empresaId é um array de empresas
 * @returns
 */
export const usuario = async (pessoaId, empresaId) => {
    try {
        const { data } = await api.get('/serviceUSUARIO', { params: { pessoaId, empresaId } });
        return data;
    } catch (error) {
        return error;
    }
};

export const login = async (usuario) => api.post('/login', usuario);

// assinaturas
export const assinatura = async ({ empresaIds, empresaId, usuario, senha, uuid, tabela }) => {
    try {
        const { data } = await api.post('/assinaturas', { empresaIds, empresaId, usuario, senha, uuid, tabela });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const assinarMovimento = async (obj) => {
    try {
        const data = await api.post('/assinarMovimento', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const assinarHomologacao = async (payload) => {
    try {
        const { data } = await api.post('/assinarHomologation', payload);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const removerAssinaturaHomologacao = async (payload) => {
    try {
        const data = await api.post('/removerAssinaturaHomologation', payload);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

/**
 *
 * @param {*} empresaId
 * @param {*} pessoaId
 * busca a permissão do usuário para gerenciar usuario no cadastro de pessoas
 * @returns
 */
export const buscaUsuarioPermitido = async (empresaId, pessoaId) => {
    try {
        const { data } = await api.get('/usuario/buscaUsuarioPermitido', { params: { pessoaId, empresaId } });
        return data;
    } catch (error) {
        return error;
    }
};

export const datalist = async ({ globalFilter, ativo }) => {
    try {
        const { data } = await api.post('/usuario/datalist', { globalFilter, ativo });
        return data;
    } catch (error) {
        return error;
    }
};
